/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import { useState } from 'react';

import TrainingDivisionScreen from './TrainingDivisionScreen';

import { Container, Wrapper } from './styles';

type Props = {
  refreshProgram: () => Promise<void>;
};

export default function Premium({ refreshProgram }: Props) {
  const [, setLockNextScreen] = useState(true);

  function lockScreen(value: boolean) {
    setLockNextScreen(value);
  }

  return (
    <Container>
      <Wrapper>
        <TrainingDivisionScreen
          lockScreen={lockScreen}
          refreshProgram={refreshProgram}
        />
      </Wrapper>
    </Container>
  );
}
